import React from "react";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import HomeScreens from "./Home";
import { Text, View } from "react-native";
import { STYLES } from "../assets/styles";
import { FontAwesome } from "@expo/vector-icons";
import CartScreens from "./cart";
import Favourites from "./favourite/Favourites";
import ProfileScreens from "./profile";
import Notifications from "./notification/Notifications";
import { connect } from "react-redux";
import Launch from "./Launch";

const Tab = createBottomTabNavigator();

function Tabs({ userOption }) {
  const tabs = [
    { name: "home", component: HomeScreens },
    { name: "notif", component: Notifications },
    { name: "favourite", component: Favourites },
    { name: "profile", component: ProfileScreens },
    { name: "cart", component: CartScreens },
  ];
  const iconProps = {
    home: {
      iconName: "home",
      label: "Home",
    },
    notif: {
      iconName: "bell",
      label: "Notifications",
    },
    favourite: {
      iconName: "heart",
      label: "Favourites",
    },
    profile: {
      iconName: "user-circle-o",
      label: "Profile",
    },
  };

  const TabIcons = ({ routeName, focused }) => {
    const { iconName, label } = iconProps[routeName];
    return (
      <View
        style={{
          width: "100%",
          height: "90%",
          padding: 2,
          borderRadius: 5,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <View
          style={{
            flexDirection: "row",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 5,
            backgroundColor: focused ? "black" : "white",
          }}
        >
          <FontAwesome
            name={iconName}
            style={{
              color: focused ? "white" : "black",
              fontSize: focused
                ? STYLES.fontSizes.large * 0.9
                : STYLES.fontSizes.xlarge,
            }}
          />
          {focused ? (
            <Text
              style={{
                color: "white",
                fontSize: STYLES.fontSizes.small * 0.75,
                marginLeft: 5,
              }}
            >
              {label}
            </Text>
          ) : null}
        </View>
      </View>
    );
  };

  return (
    <>
      {userOption.itemsFilter ? (
        <Tab.Navigator
          screenOptions={({ route }) => ({
            tabBarButton: ["cart"].includes(route.name)
              ? () => null
              : undefined,
            tabBarIcon: ({ focused }) => (
              <TabIcons routeName={route.name} focused={focused} />
            ),
          })}
          tabBarOptions={{
            showLabel: false,
            iconStyle: { width: "100%" },
          }}
          lazy={true}
          sceneContainerStyle={{ flex: 1 }}
        >
          {tabs.map(({ name, component }, index) => (
            <Tab.Screen key={index + "t"} name={name} component={component} />
          ))}
        </Tab.Navigator>
      ) : (
        <Launch />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  userOption: state.filter.userOption,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Tabs);
